import { Player } from "../Player";
import PlayerState, { PlayerStateTypes } from "./PlayerState"

export default class PlayerStateFall extends PlayerState {
    constructor(player: Player, imgPrefix: string) {
        super(player, imgPrefix, PlayerStateTypes.Fall);
    }

    update(dt: number): void {
        if (this.player.planckBody.velocity.y <= 0) {
            // stop this update cycle
            this.player.currentState = null;

            // fly up
            if (Math.abs(this.player.planckBody.velocity.y) >= Math.abs(this.player.planckBody.velocity.x * 2)) {
				this.player.emit(PlayerStateTypes.Fly);
			} else {
				this.player.emit(PlayerStateTypes.Launch);
			}        
        } 
    }
}